import { DEFAULT_HTTP_CONNECTION_LIMIT } from './consts';
import * as FileUtil from './file';
import initHttpService from './https';
import * as TaskUtil from './task';

/**
 * OSS upload
 */
class Oss {
  /**
   * @param config - The sdk config options
   */
  constructor(config = {}) {
    const {
      requestThread,
      fileChunkSize
    } = config;
    this.queue = [];
    this.availableThread = requestThread || DEFAULT_HTTP_CONNECTION_LIMIT;
    this.fileChunkSize = fileChunkSize;
    this.httpService = initHttpService(config);
  }

  /**
   * Decrease worker count
   */
  consumeWorker() {
    --this.availableThread;
  }

  /**
   * Increase worker count
   */
  releaseWorker() {
    ++this.availableThread;
  }

  /**
   * Check if there is available worker
   */
  hasAvailableWorker() {
    return this.availableThread > 0;
  }

  /**
   * Update upload queue
   */
  updateQueue(data) {
    FileUtil.updateQueue(this.queue, data);
  }

  /**
   * Setup basic upload option to trigger file upload
   */
  upload(input, options) {
    return new Promise((resolve, reject) => {
      const handleFailure = error => reject(error);
      options.onSuccess = res => resolve(res);
      options.onFailure = handleFailure;
      options.onAbort = handleFailure;
      this.uploadFile(input, options);
    });
  }

  /**
   * Push file to upload queue and start the worker
   */
  uploadFile(input, options) {
    const filesize = FileUtil.getFileSize(input, options.filesize);
    const normalizedFile = FileUtil.normalizeFile({
      file: input,
      size: filesize,
      objectId: options.objectId,
      fileChunkSize: options.fileChunkSize || this.fileChunkSize || FileUtil.getChunkSize(filesize),
      options
    });
    this.queue.push(normalizedFile);
    this.startTaskWorker();
  }

  /**
   * Delete file from OSS
   */
  async delete(objectId, options) {
    return this.httpService.deleteFile(objectId, options);
  }

  /**
   * Run specific worker task
   */
  async runTask(task) {
    this.consumeWorker();
    await task();
    this.releaseWorker();
    this.startTaskWorker();
  }

  /**
   * Start worker
   */
  startTaskWorker() {
    if (!this.hasAvailableWorker()) {
      return;
    }
    const task = TaskUtil.getWorkerTask({
      queue: this.queue,
      httpService: this.httpService,
      onUpdateStatus: this.updateQueue.bind(this)
    });
    if (!task) {
      return;
    }
    this.runTask(task);
    this.startTaskWorker(); // start next task worker in parallel
  }
}
export default Oss;